import { render, staticRenderFns } from "./SvgEdit.vue?vue&type=template&id=3f64364f&scoped=true&"
import script from "./SvgEdit.vue?vue&type=script&lang=js&"
export * from "./SvgEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f64364f",
  null
  
)

export default component.exports